import { Button } from "@/components/ui/button/button";
import { SelectField } from "@/components/ui/form/fields/select-field";
import { DatePickerRange } from "@/components/ui/input/date-picker-range";

import { RESERVATION_REQUEST_STATUS_OPTIONS, RESERVATION_TYPE_OPTIONS } from "./constants";
import { useHandleSearchActions } from "./hooks";
import { SearchByBasicLayout } from "../../../../_shared";

import type * as Model from "../../../model";

type Props = {
	// 予約の検索
	onSearchReservationRequestList: (props: Model.UseCase.SearchReservationRequestListProps) => void;
};

export const BasicSearchActionsComposition = ({ onSearchReservationRequestList }: Props) => {
	const {
		//
		searchState,
		disabled,
		//
		// 予約タイプの変更
		handleChangeReservationType,
		// リクエスト予約ステータスの変更
		handleChangeReservationRequestStatus,
		// 日付の変更
		handleChangeFromAndTo,
		// 予約の検索
		handleClickSearchReservationList,
	} = useHandleSearchActions(onSearchReservationRequestList);

	return (
		<SearchByBasicLayout>
			{/* 検索タイプ */}
			<SelectField
				value={searchState.reservationType}
				options={RESERVATION_TYPE_OPTIONS}
				handleValueChange={handleChangeReservationType}
			/>

			{searchState.reservationType !== "monthCount" && (
				<>
					{/* リクエスト予約ステータス */}
					<SelectField
						value={searchState.reservationRequestStatus}
						options={RESERVATION_REQUEST_STATUS_OPTIONS}
						handleValueChange={handleChangeReservationRequestStatus}
					/>

					{/* 日付での絞り込み */}
					<DatePickerRange
						selected={{
							from: searchState.from,
							to: searchState.to,
						}}
						onSelect={handleChangeFromAndTo}
						showPresetOptions="all-options"
						canSelectPastDate
						className="w-full tablet:w-80"
					/>
				</>
			)}

			<Button type="button" size="sm" disabled={disabled} onClick={handleClickSearchReservationList}>
				検索
			</Button>
		</SearchByBasicLayout>
	);
};
